// Som de "novo chamado" — preferência POR USUÁRIO/dispositivo (localStorage).
// Valores: "off" | "chime" | "voice" | "both". Padrão: "off" (nada toca até a
// pessoa ativar no Meu Perfil). Os arquivos ficam em /sounds (public do front).

const KEY = "bendesk_ticket_sound";
export const SOUND_OPTIONS = [
  { value: "off", label: "Desligado" },
  { value: "chime", label: "Só o som (chime)" },
  { value: "voice", label: "Só a voz (“Novo chamado!”)" },
  { value: "both", label: "Som + voz" },
];

export function getSoundPref() {
  try {
    return localStorage.getItem(KEY) || "off";
  } catch {
    return "off";
  }
}
export function setSoundPref(v) {
  try {
    localStorage.setItem(KEY, v);
  } catch {
    /* ignore */
  }
}

let _chime = null;
let _voice = null;
let _unlocked = false;

function els() {
  if (!_chime) {
    _chime = new Audio("/sounds/chime-novo-chamado.wav");
    _chime.preload = "auto";
  }
  if (!_voice) {
    _voice = new Audio("/sounds/voz-novo-chamado.wav");
    _voice.preload = "auto";
  }
  return { chime: _chime, voice: _voice };
}

// Política de autoplay: o navegador só toca áudio depois de um gesto do usuário.
// No 1º clique/tecla, "destravamos" os áudios (play mudo + pause) pra que os
// toques automáticos posteriores funcionem.
export function unlockAudioOnce() {
  if (_unlocked) return;
  const doUnlock = () => {
    if (_unlocked) return;
    const { chime, voice } = els();
    [chime, voice].forEach((a) => {
      a.muted = true;
      a.play()
        .then(() => {
          a.pause();
          a.currentTime = 0;
          a.muted = false;
        })
        .catch(() => {
          a.muted = false;
        });
    });
    _unlocked = true;
    window.removeEventListener("pointerdown", doUnlock);
    window.removeEventListener("keydown", doUnlock);
  };
  window.addEventListener("pointerdown", doUnlock);
  window.addEventListener("keydown", doUnlock);
}

function playOne(a) {
  try {
    a.currentTime = 0;
    a.play().catch(() => {});
  } catch {
    /* ignore */
  }
}

// Toca conforme a preferência (ou a forçada, ex.: botão "testar").
export function playNewTicketSound(force) {
  const pref = force || getSoundPref();
  if (pref === "off") return;
  const { chime, voice } = els();
  if (pref === "chime") playOne(chime);
  else if (pref === "voice") playOne(voice);
  else if (pref === "both") {
    playOne(chime);
    setTimeout(() => playOne(voice), 750); // voz logo após o chime
  }
}
